import {type StrNum} from "_types";


const _ = <P extends StrNum[]>(...args: P) => ['client', ...args];

export const clientRoutes = {
    attendance: (id: string) => ({
        show: _('attendances', id),
        end: _('attendances', id, 'end'),
        nps: _('attendances', id, 'nps'),
        chatToken: _('attendances', id, 'chat-token'),
    }),

    desks: {
        listByCourt: (id: string) => _('desks', 'court', id),
    },
    desk: (id: string) => ({
        show: _('desks', id),
        token: _('desks', id, 'token'),
        chatToken: _('desks', id, 'chat-token'),
    }),

    chat: {
        messages: <R extends string>(id: R) => ({
            list: _('chat', id),
        }),

        send: _('chat', 'bot'),
    },

    conferences: {
        store: _('conferences'),
    },
    conference: (id: string) => ({
        show: _('conferences', id),
        end: _('conferences', id, 'end'),
        nps: _('conferences', id, 'nps'),
        chatToken: _('conferences', id, 'chat-token'),
    }),

    conferenceDesks: {
        listByCourt: (id: string) => _('conference-desks', 'court', id),
    },
    conferenceDesk: (id: string) => ({
        show: _('conference-desks', id),
        token: _('conference-desks', id, 'token'),
        chatToken: _('conference-desks', id, 'chat-token'),
    }),

    hearings: {
        search: _('hearings'),
    },
    hearing: (id: string) => ({
        show: _('hearings', id),
        chatToken: _('hearings', id, 'chat-token'),
    }),

    protocols: {
        search: _('protocols'),
    },

    search: {
        court: _('search'),
        assignments: _('search', 'assignments'),
        counties: _('search', 'counties'),
        regionals: _('search', 'regionals'),
    },
}
